import { gql } from 'apollo-angular';

export var nav_search_sponsors = gql`
  query navSearchSponsors(
    $searchLike: String!
    $search: String!
    $limit: Int!
    $page: Int
  ) {
    search_sponsors(
      first: $limit
      name: $searchLike
      orderByInstr: [{ column: NAME, search: $search, order: ASC }]
      page: $page
    ) {
      data {
        id
        name
      }
      paginatorInfo {
        currentPage
        lastPage
      }
    }
  }
`;
